import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import { showPdf } from '../../../shared/helpers/files';


const getAll = async ( params = {} ) => {

  const {
    search, doctor, 
    establecimiento, estadoImagen, tipoImagen, 
    fechaDesde, fechaHasta, page, pageSize, excel, 
    idPaciente, tipoFecha, tipoCobertura,
    observaciones
  } = params;

  const query = `
    query GetAllEnvioImagenes(
      $idPaciente: ID,
      $search: String,
      $establecimiento: String,
      $fechaDesde: Date,
      $fechaHasta: Date,
      $estadoImagen: String,
      $page: Int,
      $pageSize: Int,
      $doctor: ID,
      $tipoImagen: String,
      $excel: String,
      $tipoFecha: String,
      $tipoCobertura: String,
      $observaciones: String
    ) {
      allEnviosImagen(
        idPaciente: $idPaciente
        search: $search
        establecimiento: $establecimiento
        fechaDesde: $fechaDesde
        fechaHasta: $fechaHasta
        estadoImagen: $estadoImagen
        page: $page
        pageSize: $pageSize
        doctor: $doctor
        tipoImagen: $tipoImagen
        tipoCobertura: $tipoCobertura
        excel: $excel
        tipoFecha: $tipoFecha
        observaciones: $observaciones
      ) {
        total
        status
        message
        dataarchivo
        enviosImagen {
          id
          token
          numeroOrdenAs400
          motivoSolicitud
          resumenClinico
          fechaProgramada
          fechaCreacion
          usuarioCreador {
            username
          }
          estadoImagen
          imagen {
            id
            codigo
            nombre
          }
          consultamedica {
            envioimagenSet {
              informes {
                conclusionImagen
                id
                token
                informeImagen
                urlCarpetaImagenes
                urlMsp
                urlInforme
                urlMspTitular1
                urlMspTitular2
                urlMspTitular3
                imagenologo {
                  id
                  idPersona {
                    primerApellido
                    primerNombre
                    id
                    identificacion
                  }
                }
                diagimageninformeSet {
                  id
                  estado
                  diagnostico {
                    id
                    codigo
                    descripcion
                  }
                }
              }
              token
              estado
              imagen {
                id
                nombre
                codigo
                tipoImagen {
                  descripcion
                  id
                }
              }
              lateralidad {
                descripcion
                id
              }
              sedacion
              numeroOrdenAs400
              motivoSolicitud
              resumenClinico
              alertaIgnorada
            }
            cita {
              detallescitaSet {
                id
                detailsSeguro
                detallesTitulares
              }
              fechaCita
              horaCita
              id
              urlCodigoDer
              urlDerivacion
              urlsMspPaciente
              urlsMspTitular1
              urlsMspTitular2
              urlsMspTitular3
              urlSolImgDer
              url007Recibido
              fecderivacion
              codderivacion
              cobSeleccionada {
                id
                descripcion
              }
              paciente {
                id
                persona {
                  primerNombre
                  identificacion
                  primerApellido
                }
              }
              doctor {
                id
                idPersona {
                  primerApellido
                  primerNombre
                }
              }
              establecimiento {
                id
                Descripcion
              }
            }
          }
          informes {
            urlMsp
            urlMspTitular1
            urlMspTitular2
            urlMspTitular3
          }
        }
        pageInfo {
          currentPage
          totalPages
          hasNextPage
          hasPreviousPage
        }
      }
    }
  `;

  const variables = {
    idPaciente     : idPaciente,
    search         : search,
    establecimiento: establecimiento,
    doctor         : doctor,
    estadoImagen   : estadoImagen,
    tipoImagen     : tipoImagen,
    fechaDesde     : fechaDesde,
    fechaHasta     : fechaHasta,
    page           : page,
    pageSize       : pageSize,
    excel          : excel,
    tipoFecha      : tipoFecha,
    tipoCobertura  : tipoCobertura,
    observaciones: observaciones
  };

  try{

    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.allEnviosImagen;
    if(response2.status !== 'Success') return null;

    const data = response2.enviosImagen;   

    return {
      data,
      dataarchivo : response.data.data.allEnviosImagen.dataarchivo,
      total: response2.total
    };

  }catch(error){
    console.error('Error al las imagenes enviadas');
  }
}

const getReporteImagenes = async ( params = {} ) => {

  const {
    search, doctor, 
    establecimiento, estadoImagen, tipoImagen, 
    fechaDesde, fechaHasta, idPaciente, tipoFecha
  } = params;

  const query = `
    query reporteImagenes(
      $idPaciente      : ID,
      $search          : String, 
      $establecimiento : String, 
      $fechaDesde      : Date, 
      $fechaHasta      : Date, 
      $estadoImagen    : String,     
      $doctor          : ID,
      $tipoImagen      : String,      
      $tipoFecha       : String
    ) {
      reporteImagenes(
        idPaciente      : $idPaciente
        search          : $search
        establecimiento : $establecimiento
        fechaDesde      : $fechaDesde
        fechaHasta      : $fechaHasta
        estadoImagen    : $estadoImagen
        doctor          : $doctor
        tipoImagen      : $tipoImagen
        tipoFecha       : $tipoFecha
      ) 
}
  `;

  const variables = {
    idPaciente     : idPaciente,
    search         : search,
    establecimiento: establecimiento,
    doctor         : doctor,
    estadoImagen   : estadoImagen,
    tipoImagen     : tipoImagen,
    fechaDesde     : fechaDesde,
    fechaHasta     : fechaHasta,
    tipoFecha      : tipoFecha
  };

  try{

    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.reporteImagenes;
    if(!response2) return null;

    const data = response2;
    return {
      dataarchivo : data,
     
    };

  }catch(error){
    console.error('Error reporte imagenes');
  }
}

const getByToken = async ( tokenImagen ) => {

  if( !tokenImagen ) {
    console.error("No se proporciono un token de imagen");
    return null;
  }

  const query = `
    query EnvioImagen($tokenImagen: String) {
      envioImagen(tokenImagen: $tokenImagen) {
        enviosImagen {
          id
          token
          fechaCreacion
          fechaProgramada
          estadoImagen
          numeroOrdenAs400
          motivoSolicitud
          resumenClinico
          justificacion
          sedacion
          imagen {
            id
            token
            nombre
            codigo
          }
          lateralidad {
            id
            nombre
          }
          informes {
            id
            estado
            urlMsp
            urlMspTitular1
            urlMspTitular2
            urlMspTitular3
            imagenologo {
              id
              idPersona {
                primerApellido
                segundoApellido
                primerNombre
                segundoNombre
              }
            }

            diagimageninformeSet {
              id
              token
              estado
              diagnostico {
                id
                codigo
                estado
                descripcion
                token
              }
            }
            urlDicomModificado
            urlCarpetaImagenes
            urlCarpetaImagenesDicom
            conclusionImagen
            urlInforme
            informeImagen
            fechaCreacion
          }

          consultamedica {
            cita {
            id
              paciente {
                id
                persona {
                  id
                  primerApellido
                  segundoApellido
                  primerNombre
                  segundoNombre
                  identificacion
                  correo
                  telefono
                }
              }
              doctor {
                token
                id
                especialidad {
                  descripcion
                }
                idPersona {
                  segundoNombre
                  primerNombre
                  segundoApellido
                  primerApellido
                }
              }
            }
          }
        }
        message
        status
      }
    }
  `;

  const variables = {
    tokenImagen
  };

  try {
    const response = await axios.post(rutas.axios + "api", { query, variables });
    
    if(response.status !== 200) return null;
    const response2 = response.data.data.envioImagen;
    if( response2.status !== 'Success' ) return null;
    const data = response2.enviosImagen;
    return data;
  } catch (error) {
    console.error("Ocurrio un error al buscar la imagen por token", error);
    return null;
  }
}


const getByPacienteId = async ( pacienteId ) => {
  const query = `
    query buscarImagenesPorIdPaciente($pacienteId: ID!) {
      envioImagenPacienteid(idpaciente: $pacienteId) {
        message, status, total
        enviosImagen {
          id
        }
      }
    }
  `;
  const variables = { pacienteId };

  try {
    const response = await axios.post(rutas.axios + "api", { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.envioImagenPacienteid;

    return response2;

  } catch (error) {
    console.error("Ocurrio un error", error);
    return null;
  }
}

const crearInforme = async ( informeImagenData ) => {

  const informeImagenDataString = JSON.stringify(informeImagenData);

  const query = `
    mutation CrearInformeImagen(
      $informeEnvioImagen: String!
    ) {
      ejecutarInformeImagen(
        informeenvioimagen: $informeEnvioImagen
      ) {
        message
        status
        informeenvioimagen {
          informeImagen
          conclusionImagen
          urlInforme
          envioImagen {
            id
          }
        }
      }
    }
  `;

  const variables = {
    informeEnvioImagen: informeImagenDataString
  };

  try {

    const response = await axios.post(rutas.axios + 'api', { query, variables });
    return response.data.data.ejecutarInformeImagen;

  } catch (error) {
    console.error(error);
    return error;
  }
}


const actualizarInforme = async (informeImagenData) => {
  // Normalizar payload para cubrir backends que esperan snake_case o camelCase
  const payload = { ...informeImagenData };

  // Texto del informe y conclusión
  if (payload.informe_imagen !== undefined && payload.informeImagen === undefined) {
    payload.informeImagen = payload.informe_imagen;
  }
  if (payload.conclusion_imagen !== undefined && payload.conclusionImagen === undefined) {
    payload.conclusionImagen = payload.conclusion_imagen;
  }

  // URLs de archivos/imágenes (PDF/ZIP/DICOM)
  if (payload.url_informe !== undefined && payload.urlInforme === undefined) {
    payload.urlInforme = payload.url_informe;
  }
  if (payload.url_carpeta_imagenes !== undefined && payload.urlCarpetaImagenes === undefined) {
    payload.urlCarpetaImagenes = payload.url_carpeta_imagenes;
  }
  if (payload.url_carpeta_imagenes_dicom !== undefined && payload.urlCarpetaImagenesDicom === undefined) {
    payload.urlCarpetaImagenesDicom = payload.url_carpeta_imagenes_dicom;
  }
  if (payload.url_dicom_modificado !== undefined && payload.urlDicomModificado === undefined) {
    payload.urlDicomModificado = payload.url_dicom_modificado;
  }

  // Anotaciones DICOM (si llegan como objeto, asegurar serialización segura)
  if (payload.dicomAnnotations !== undefined && typeof payload.dicomAnnotations !== 'string') {
    try { payload.dicomAnnotations = JSON.stringify(payload.dicomAnnotations); } catch (_) {}
  }

  // Diagnósticos: además del arreglo de objetos, enviar arreglo de IDs
  if (Array.isArray(payload.diagnosticos) && payload.diagnosticos_ids === undefined) {
    payload.diagnosticos_ids = payload.diagnosticos
      .map(d => (d && (d.diagnostico || d.id || d.value)))
      .filter(Boolean);
  }

  const query = `
    mutation actualizarInformeImagen($informeEnvioImagen: String!) {
      actualizarInformeImagen(informeenvioimagen: $informeEnvioImagen) {
        message
        status
        informeenvioimagen {
          informeImagen
          conclusionImagen
          urlInforme
          urlCarpetaImagenes 
          urlCarpetaImagenesDicom
          urlDicomModificado   
          dicomAnnotations
          envioImagen { id }
        }
      }
    }
  `;
  const variables = { informeEnvioImagen: JSON.stringify(payload) };
  const response = await axios.post(rutas.axios + 'api', { query, variables });
  return response.data.data.actualizarInformeImagen;
}



const getByAtencion = async ( tokenAtencion ) => {

  if( !tokenAtencion ) {
    console.error('token atencion es requerido');
    return null
  }

  const query = `
    query AllAtenmedica($tokenAtencion: String) {
      allAtenmedica(tokenAtencion: $tokenAtencion) {
        total
        status
        message
        atcm {
          id
          token
          envioimagenSet {
            id
            estado
            token
            estadoImagen
            lateralidad {
              id
              nombre
            }
            imagen {
              id, token, codigo,
              nombre
            }
            motivoSolicitud
            numeroOrdenAs400
            resumenClinico
            sedacion
            justificacion
          }
        }
      }
    }
  `;

  const variables = {
    tokenAtencion
  };

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.allAtenmedica;
    
    if( response2.status !== 'success' ) return null;
    if( response2.atcm.length === 0 ) return null;
    if( response2.atcm[0].envioimagenSet.length === 0 ) return null;

    const data = response2.atcm[0].envioimagenSet;
    const dataActivos = data.filter( i => i.estado === '1')
    return dataActivos;
  }catch (error) {
    console.error('Error al traer las imagenes de la atencion', error);
    return null;
  }

}


const registerEnvio = async ( idAtencion, dataImagenes) => {

  if(!idAtencion) {
    console.error('id atencion es requerido');
    return null
  }

  if(!dataImagenes || dataImagenes.length === 0) {
    console.error('data imagenes es requerido');
    return null
  }

  const query = `
    mutation CrearEnviosImagen(
      $enviosDatos: [EnvioImagenInput!]!,
      $atencionMedica: String!
    ) {
      crearEnviosImagen(
        enviosDatos: $enviosDatos,
        atencionMedica: $atencionMedica
      ) {
        enviosImagen {
          id
          token
          imagen {
            id
            nombre
          }
        }
        status
        message
      }
    }
  `;

  const solicitudesImagen = dataImagenes.map((item) => ({
    imagenId        : item.imagenId,
    diagnostico     : item.diagnostico || null,
    motivoSolicitud : item.motivosolicitud,
    numeroOrdenAs400: item.norden,
    resumenClinico  : item.resumen,
    lateralidadId   : parseInt(item.lateralidadId, 10),
    alertaIgnorada  : item.alertaIgnorada,
    justificacion   : item.justificacion || null,
    sedacion        : item.sedacion || '2'
  }));

  const variables = {
    enviosDatos: solicitudesImagen,
    atencionMedica: idAtencion,
  };

  try {
      
    const response = await axios.post(rutas.axios + "api", { query, variables });
    if (response.status !== 200) return null;

    const response2 = response.data.data.crearEnviosImagen;
    if (response2.status !== "Success") return null;

    const data = response2.enviosImagen;
    return data;
    
  } catch (err) {
    console.error('Error al registrar las imagenes', err);
    return null;
  }
}


const updateEnvio = async (idAtencion, dataImagenes) => {

 
  if(!dataImagenes || dataImagenes.length === 0) {
    console.error('data imagenes es requerido');
    return null
  }

  const query = `
    mutation editarEnviosImgAtencion(
      $enviosDatos: [EnvioImagenUpdateInput!]!,
       $atencionMedica: String!
    ) {
      editarEnviosImgAtencion(
        enviosDatos: $enviosDatos,
        atencionMedica: $atencionMedica
      ) {
        enviosImagen {
          id
          token
          imagen {
            id
            nombre
          }
        }
        status
        message
      }
    }
  `;

  const solicitudesImagen = dataImagenes.map((item) => ({
    imagenId        : item.imagenId,
    diagnostico     : item.diagnostico || null,
    motivoSolicitud : item.motivosolicitud,
    numeroOrdenAs400: item.norden,
    resumenClinico  : item.resumen,
    lateralidadId   : parseInt(item.lateralidadId, 10),
    alertaIgnorada  : parseInt(item.alertaIgnorada, 10),
    tokenEnvioImagen: item.tokenEnvioImagen,
    justificacion   : item.justificacion || null,
    estado : item.estado

  }));

  const variables = {
    enviosDatos: solicitudesImagen,
    atencionMedica: idAtencion,
    
  };

  try {
      
    const response = await axios.post(rutas.axios + "api", { query, variables });
    
    if (response.status !== 200) return null;

    const response2 = response.data.data.editarEnviosImgAtencion;

    if (response2.status !== "Success") return null;

    const data = response2.enviosImagen;
    return data;
    
  } catch (err) {
    console.error('Error al registrar las imagenes', err);
    return null;
  }
}


const processEnvios = async (tokenAtencion, dataImagenes) => {
  
  // class processEnviosImagenesInput(graphene.InputObjectType):
  //   action          = graphene.String(required=True)
  //   imagenId        = graphene.String(required=True)
  //   numeroOrden     = graphene.String()
  //   lateralidad     = graphene.String()
  //   motivoSolicitud = graphene.String()
  //   resumenClinico  = graphene.String()
  //   sedacion        = graphene.String()
  //   justificacion   = graphene.String()
  //   idRegistro      = graphene.String() 

  if(!tokenAtencion){
    console.error('token de la atencion es requerido');
    return null;
  }

  if(!dataImagenes || dataImagenes.length === 0){
    console.error('data imagenes es requerido');
    return null;
  }

  const query = `
    mutation ProcessEnviosImagenes(
      $atencionMedica: String!
      $imagenesToProcess:[processEnviosImagenesInput]!
    ) {
      processEnviosImagenes(
        atencionMedica   : $atencionMedica,
        imagenesToProcess: $imagenesToProcess
      ) {
        message
        status
        imagenesProcesadas
      }
    }
  `;

  const variables = {
    atencionMedica: tokenAtencion,
    imagenesToProcess: dataImagenes
  }

  try{
    
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.processEnviosImagenes;
    if( response2.status !== 'success' ) return null;
    
    const data = response2.imagenesProcesadas;
    return data;
    
  }catch(error){
    console.error('Error al registrar las imagenes', error);
    return null;
  }
}


const getAllSns = async (search = '') => {

  const query = `
    query AllImagenesSns($search: String) {
      allImagenesSns(search: $search) {
        total
        status
        message
        imagenes {
          id
          token
          nombre
          codigo
        }
      }
    }
  `;

  const variables = { search };

  try{
    const response = await axios.post( rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.allImagenesSns;
    if( response2.status !== 'success' ) return null;
    const data = response2.imagenes;
    return data;
    
  }catch(error){
    console.error('Error al traer las imagenes sns', error);
    return null;
  }
}


const getUrlView12b = async (tokenImagen) => {

  const query = `
    query InformeImagen12bByToken($tokenImagen: String!) {
      informeImagen12b(tokenImagen: $tokenImagen) {
        status
        message
        imgarchivo
      }
    }
  `;

  const variables = {
    tokenImagen 
  }

  try {
    const response = await axios.post(rutas.axios + "api", { query, variables });
    if (response.status !== 200) return null;

    const response2 = response.data.data.informeImagen12b;
    if (response2.status !== 'success') return null;

    const dataPdf = response2.imgarchivo;
    if (!dataPdf) return null;

    const tempUrl = showPdf(dataPdf);
    return tempUrl;
    
  } catch (error) {
    console.error('error obtener url view 12b', error);
    return null;
  }
}

export const imagenesService = {

  getAll,

  getByToken,
  getByPacienteId,
  crearInforme,
  getByAtencion,
  registerEnvio,
  updateEnvio,
  actualizarInforme,
  getReporteImagenes,

  processEnvios,

  getAllSns,
  getUrlView12b
}
